// extracted by mini-css-extract-plugin
export default {"selected":"selected--3guUqNY"};